import React from "react";

const Navigation = ({ isFirstPage, isLastPage, onPrevious, onNext }) => {
    return (
        <div
            className={`d-flex mt-4 ${
                isFirstPage ? "justify-content-end" : "justify-content-between"
            }`}
        >
            {!isFirstPage && (
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onPrevious}
                >
                    Previous
                </button>
            )}

            {!isLastPage && (
                <button type="button" className="btn btn-primary" onClick={onNext}>
                    Next
                </button>
            )}

            { isLastPage &&(
                <button type="submit" className="btn btn-success">
                    Submit Survey
                </button>
            )}
        </div>
    );
};

export default Navigation;
